<template>
  <div>
    <div>
      <loading-imgs v-if="loading"/>
    </div>
    <div v-if="ApiResponse == true">
      <ValidadorDocs/>
    </div>
    <div v-else>
      <main class="base_cadastro" :class="{'modo-escuro': modoEscuro}">
        <router-view :dadosgr="dados"/>
      </main>
    </div>
    </div>
</template>

<script>
import {ConsultaUsuario} from "@/controllers/consulta-usuario";
import {verificaRota} from "@/domain/verifica-rota";
import LoadingImgs from "@/components/shared/LoadingImgs.vue";
import ValidadorDocs from "@/components/validador-documentos.vue";

export default {
  name: "App",
  components: {ValidadorDocs, LoadingImgs},
  data() {
    return {
      modoEscuro: false,
      loading: true,
      etapa: 1,
      dados: [],
      dadosCarregados: false,
      dadosTeste: true,
      ApiResponse: true,
    };
  },
  created() {
    this.getDados();
  },

  methods: {
    async getDados() {
      this.loading = true
      const response = await ConsultaUsuario();
      const res = response.data
      if (res != undefined && response.status != undefined) {
        this.dados = res[0];
        this.etapa = this.dados.etapa;
        this.dadosCarregados = true;
        this.loading = false;
        this.redirecionarUsuario();
        this.ApiResponse = false;
      } else {
        this.ApiResponse = (response.response.status == 401 && localStorage.getItem('apiResponse')) ? false : true;
        this.dados = [];
        this.dadosCarregados = true;
        this.loading = false;
        localStorage.removeItem('token');
        localStorage.removeItem('token_username');
        localStorage.removeItem('id');
        localStorage.removeItem('bn_pessoajuridica');
        localStorage.removeItem('statusestadocivil_id');
        localStorage.removeItem('etapa');

        sessionStorage.removeItem('token');
        sessionStorage.removeItem('token_username');
        sessionStorage.removeItem('id');
        sessionStorage.removeItem('bn_pessoajuridica');
        sessionStorage.removeItem('statusestadocivil_id');
        sessionStorage.removeItem('etapa');
      }
    },
    redirecionarUsuario() {
      if (this.dadosCarregados) {
        if (this.etapa == null) {
          if (this.dados.bn_pessoajuridica) {
            this.$router.push({name: "PsJuridica_idEdita"});
          }
          this.$router.push({name: "index_idEdita"});
        } else {
          if (verificaRota(this.dados.statusliberacaoonline_id)) {
            this.etapa = 1;
            if (this.dados.bn_pessoajuridica) {
              this.$router.push({name: "PsJuridica_idEdita"});
            }
          } else {
            if (this.etapa !== null && this.etapa !== undefined) {
              const etapasPossiveis = {
                1: "formulario",
                2: "codigo",
                3: "endereco",
                4: "documento",
              };
              const etapaAtual = etapasPossiveis[this.etapa + 1];

              if (etapaAtual) {
                if (this.dados.bn_pessoajuridica) {
                  this.$router.push({name: "PsJuridica_idEdita"});
                }

                this.$router.push({name: etapaAtual});
                const urlParts = this.$route.fullPath;
                sessionStorage.setItem("ultima_rota", urlParts);
              }
            } else {
              this.$router.push({name: "formulario"});
            }
          }
        }
      }
    },
  }
};
</script>

<style>
.base_cadastro {
  padding: 0;
  margin: 0;
  height: 100%;
  font-family: FontPadraoRegularCond !important;
  box-sizing: border-box !important;
  z-index: 0;
  font-size: initial;
}

.modo-escuro {
  --color-base: #232323;
  --color-label-forms: #444444;
  --bd-primary: #d8d8d8;
  --bd-primary-hover: #232323;
  --bd-scroll-primary: #303030;
  --bd-scroll-primary-hover: #1a1a1a;
  --bd-base-forms: #FFF;
  --bd-inputs-gerais: rgb(167 167 167 / 22%);
  --bd-modal-comprovante: rgb(167 167 167 / 39%);
  --bd-html-padrao: #dad4d4;
  --bd-geral-black: #212121;
  --bd-geral-white: #5a5a5a;
  --bd-project: #070707 !important;
}

@media (max-width: 551px) {
  html {
    height: auto;
  }
}

.container_cadastro_base {
  width: 99%;
  display: flex;
  justify-content: center;
}
</style>